import { useMemo } from "react";
import { useSearch } from "@tanstack/react-router";
import { useAuth } from "./useAuth";
import {
  useUserAirlinesQuery as useUserAirlinesNonSuspenseQuery,
  useUserAirlinesSuspenseQuery,
} from "./useUserAirlinesQuery";

type UseSelectedAirlineProps = {
  useSuspense?: boolean;
};

export const useSelectedAirline = ({ useSuspense = false }: UseSelectedAirlineProps = {}) => {
  const { isAirlineUser, airlineCode: airlineCodeFromClaims } = useAuth();
  const { airlineCode: airlineCodeFromUrl } = useSearch({ strict: false }) as { airlineCode?: string };

  const useUserAirlinesQuery = useSuspense ? useUserAirlinesSuspenseQuery : useUserAirlinesNonSuspenseQuery;
  const { data: airlines } = useUserAirlinesQuery();

  const selectedAirline = useMemo(() => {
    const selectedAirlineCode = isAirlineUser ? airlineCodeFromClaims : airlineCodeFromUrl;
    return airlines?.find(({ code }) => code === selectedAirlineCode);
  }, [isAirlineUser, airlineCodeFromClaims, airlineCodeFromUrl, airlines]);

  return {
    selectedAirline,
  };
};
